import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../../contexts/LocaleContext';
import { USE_CASE_PAGES } from '../../marketing/use-case-pages';

export const WhatIs: React.FC = () => {
  const { t } = useLocale();

  return (
    <section id="what-is" className="scroll-mt-24 bg-white" style={{ padding: '96px 0 40px' }}>
      <div style={{ width: '100%', maxWidth: '1200px', margin: '0 auto', padding: '0 32px' }}>
        <div style={{ textAlign: 'center', maxWidth: '760px', margin: '0 auto 48px' }}>
          <p
            style={{
              fontFamily: "'DM Mono', monospace",
              fontSize: '16px',
              lineHeight: '20px',
              fontWeight: 500,
              letterSpacing: '3.2px',
              textTransform: 'uppercase',
              color: 'var(--scribane-green)',
              margin: '0 0 22px',
            }}
          >
            {t('landing_what_is_aux')}
          </p>
          <h2
            style={{
              fontFamily: "'Inter', system-ui, sans-serif",
              fontWeight: 800,
              fontSize: 'clamp(34px, 5vw, 56px)',
              lineHeight: 1.06,
              letterSpacing: '-0.02em',
              margin: 0,
              color: 'rgb(39,39,41)',
            }}
          >
            {t('landing_what_is_title')}
          </h2>
          <p
            style={{
              fontFamily: "'Inter', system-ui, sans-serif",
              fontSize: '18px',
              lineHeight: '28px',
              fontWeight: 400,
              color: 'rgba(39,39,41,0.75)',
              margin: '22px auto 0',
              maxWidth: '680px',
            }}
          >
            {t('landing_what_is_body')}
          </p>
        </div>

        <div className="grid grid-cols-1 gap-7 max-w-[520px] mx-auto min-[800px]:grid-cols-2 min-[800px]:max-w-none">
          <article
            style={{
              border: '1px solid #e7e7e8',
              borderRadius: '20px',
              padding: '32px 30px',
              background: '#fff',
            }}
          >
            <h3
              style={{
                fontFamily: "'Inter', system-ui, sans-serif",
                fontSize: '18px',
                fontWeight: 700,
                letterSpacing: '0.01em',
                margin: '0 0 14px',
                color: 'rgb(39,39,41)',
              }}
            >
              {t('landing_who_for_title')}
            </h3>
            <p
              style={{
                fontFamily: "'Inter', system-ui, sans-serif",
                fontSize: '15px',
                lineHeight: '26px',
                color: '#686869',
                margin: '0 0 16px',
              }}
            >
              {t('landing_who_for_body')}
            </p>
            <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {USE_CASE_PAGES.map((page) => (
                <li key={page.slug}>
                  <Link
                    to={page.path}
                    className="text-sm font-medium text-[rgb(39,39,41)] underline underline-offset-4 hover:text-[var(--scribane-green)]"
                  >
                    {t(`${page.keyPrefix}_nav_label`)}
                  </Link>
                </li>
              ))}
            </ul>
          </article>
          <article
            style={{
              border: '1px solid #e7e7e8',
              borderRadius: '20px',
              padding: '32px 30px',
              background: '#fff',
            }}
          >
            <h3
              style={{
                fontFamily: "'Inter', system-ui, sans-serif",
                fontSize: '18px',
                fontWeight: 700,
                letterSpacing: '0.01em',
                margin: '0 0 14px',
                color: 'rgb(39,39,41)',
              }}
            >
              {t('landing_what_is_not_title')}
            </h3>
            <p
              style={{
                fontFamily: "'Inter', system-ui, sans-serif",
                fontSize: '15px',
                lineHeight: '26px',
                color: '#686869',
                margin: 0,
              }}
            >
              {t('landing_what_is_not_body')}
            </p>
          </article>
        </div>
      </div>
    </section>
  );
};
